export const COLLAPSE_ANIMATION_DURATION_SECONDS = 1;
export const FLIP_ANIMATION_DURATION_SECONDS = 1;
export const DEFAULT_OVERLAY_BORDER_RADIUS = 8;
export const DEFAULT_OVERLAY_BORDER_WIDTH = 3;
export const OVERLAY_HINT_VERTICAL_PADDING = 14;

export const VISIBLE_TO_REAL_CAPTURE_WINDOW_HEIGHT_RATIO = 0.8;
export const VISIBLE_TO_REAL_CAPTURE_WINDOW_WIDTH_RATIO = 0.8;

export const SHORT_BARCODE_VISIBLE_TO_REAL_CAPTURE_WINDOW_HEIGHT_RATIO = 0.4247;
